export default {
    newPageCreateFile: "正在创建文件",
    globalConfirm: "确定",
    globalCancel: "取消",
    globalStyle: "样式",
    globalColor: "颜色",
    globalLine: "线条",
};
